// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportFileReportDashboardContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';

export default class ImportFileReportDashboardContent {
  @observable categoryId: string = null;
  @observable categoryName: string = null;
  @observable id: string = null;
  @observable isGlobal: boolean = false;
  @observable name: string = null;
  @observable subCategoryId: string = null;
  @observable subCategoryName: string = null;
  @observable type: number = 0;
  @observable index: number = 0;
  @observable sourceId: string = '';
  originalCategoryName: string = null;
  originalSubCategoryName: string = null;

  constructor(content: ImportFileReportDashboardContent) {
    this.categoryId = content.categoryId;
    this.originalCategoryName = content.categoryName;
    this.id = content.id;
    this.isGlobal = content.isGlobal;
    this.name = content.name;
    this.subCategoryId = content.subCategoryId;
    this.originalSubCategoryName = content.subCategoryName;
    this.type = content.type;
    this.index = content.index;
    this.sourceId = content.sourceId;
  }

  @action
  updateName(event: any) {
    this.name = event.target.value;
  }

  buildData() {
    return {
      categoryId: String.isGuidFormat(this.categoryId) ? this.categoryId: null,
      categoryName: this.categoryName,
      id: this.id,
      isGlobal: this.isGlobal,
      name: this.name,
      subCategoryId: String.isGuidFormat(this.subCategoryId) ? this.subCategoryId: null,
      subCategoryName: this.subCategoryName,
      type: this.type,
      index: this.index,
      sourceId: this.sourceId
    }
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ImportFileReportDashboardContent.js